// API configuration constants
// This file uses CommonJS exports to be compatible with webpack.config.js
module.exports = {
  CONFIG_API_EXTERNAL_PREFIX: 'config-api/v1/external',
  MONITOR_API_PREFIX: 'api2/v1',
  DATA_API_PREFIX: 'data-api/v1',
};

